<template>
  <v-text-field
    v-bind="$attrs"
    type="date"
    maxlength="10"
    max="9999-12-31"
    :value="value"
    :error-messages="errorMessages"
    @input="handleDateInput"
    @paste="handleDatePaste"
  />
</template>

<script>
import moment from "moment";

export default {
  name: "DateTextField",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleDateInput(value) {
      const isoMatch = value?.match(/^(\d+)-(\d{2})-(\d{2})$/);
      const localMatch = value?.match(
        /^(\d{2})[/\.\-](\d{2})[/\.\-](\d+)$/
      );

      if (isoMatch && isoMatch[1].length > 4) {
        this.$emit(
          "input",
          `${isoMatch[1].slice(0, 4)}-${isoMatch[2]}-${isoMatch[3]}`
        );
        return;
      }

      if (localMatch && localMatch[3].length > 4) {
        this.$emit(
          "input",
          `${localMatch[3].slice(0, 4)}-${localMatch[2]}-${localMatch[1]}`
        );
        return;
      }

      this.$emit("input", value);
    },

    parsePastedDate(value) {
      const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) {
        return moment(value, "YYYY-MM-DD", true);
      }

      const localMatch = value.match(/^(\d{2})[/\.\-](\d{2})[/\.\-](\d{4})$/);
      if (localMatch) {
        const [, day, month, year] = localMatch;
        return moment(`${year}-${month}-${day}`, "YYYY-MM-DD", true);
      }

      return null;
    },

    handleDatePaste(event) {
      const value = event.clipboardData?.getData("text").trim();
      if (!value) return;

      const date = this.parsePastedDate(value);
      if (!date?.isValid()) {
        const dateLikeValue = /^\d{1,2}[/\.\-]\d{1,2}[/\.\-]\d+$/.test(
          value
        );

        if (dateLikeValue) event.preventDefault();
        return;
      }

      event.preventDefault();
      this.$emit("input", date.format("YYYY-MM-DD"));
    },
  },
};
</script>
